import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TuiButton, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface GateweeAlertDialogData {
  title: string;
  message: string;
  closeLabel?: string;
}

@Component({
  selector: 'gatewee-alert-dialog',
  standalone: true,
  imports: [CommonModule, TuiButton],
  template: `
    <div class="gw-p-6 gw-space-y-4">
      <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
        {{ data.title }}
      </h2>
      <p class="gw-text-sm gw-text-text-secondary">{{ data.message }}</p>
      <div class="gw-flex gw-justify-end gw-pt-2">
        <button tuiButton appearance="primary" (click)="close()">
          {{ data.closeLabel ?? 'Ok, entendi' }}
        </button>
      </div>
    </div>
  `,
})
export class GateweeAlertDialogComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<void, GateweeAlertDialogData>,
  ) {}

  get data(): GateweeAlertDialogData {
    return this.context.data;
  }

  close(): void {
    this.context.completeWith();
  }
}
